import React, { useState, useEffect, useRef } from "react";
import "./Statistics.css";

function Statistics() {
  const [inView, setInView] = useState(false);
  const statsContainerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (statsContainerRef.current) {
        const rect = statsContainerRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          setInView(true);
          setTimeout(() => {
            if (statsContainerRef.current) {
              statsContainerRef.current.classList.add("done");
            }
          }, 2000); 
        } else {
          setInView(false);
          if (statsContainerRef.current) {
            statsContainerRef.current.classList.remove("done");
          }
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div
      className={`stats-container animate-up2 ${inView ? "in-view" : ""}`}
      ref={statsContainerRef}
    >
      <div className="stat">
        <h2>29%</h2>
        <p>of the tech industry in the UK are women*</p>
      </div>
      <div className="divider"></div>
      <div className="stat">
        <h2>90%</h2>
        <p> of women believe that the technology industry would benefit from a gender equal workforce** </p>
      </div>
      <div className="divider"></div>
      <div className="stat">
        <h2>76%</h2>
        <p> of women working in technology have experienced gender bias or discrimination in the workplace** </p>
      </div>
    </div>
  );
}

export default Statistics;
